import React from 'react';

export default function Tooltip({ text, placement = 'top', children }) {
  if (!text) return children;
  const cls = `TooltipWrap TooltipWrap--${placement}`;
  return (
    <span className={cls}>
      {children}
      <span className="TooltipBubble" role="tooltip">
        {text}
      </span>
    </span>
  );
}

